import { Component, Vue } from 'vue-property-decorator';
import { AppSettingsStore } from '@/store/store.appSettings';
import { AuthStore } from '@/store/store.auth';
import { AuthentificationService } from '@/services';

@Component
export default class DirectOpenComponent extends Vue {
    public loadingOverlay: boolean = true;
    private dataSetId?: string = '';

    // tslint:disable-next-line: no-empty
    public async mounted() {
        this.dataSetId = this.$route.params.id || undefined;
        AppSettingsStore.SetDirectOpenId(this.dataSetId);
        if (AuthStore.isLoggedIn !== true) {
            AuthentificationService.SignInRedirect();
        }
        this.goToDashboard();
    }

    private goToDashboard(): void {
        this.$router.replace({ name: 'dashboard' });
    }
}
